import * as Icons from "@nova/component-icons"
import { checkPasswordPolicy, defaultPasswordPolicy } from "@nova/password-policy"
import { PasswordPolicyResponse } from "user/authentication/types"

export const PasswordPolicyList = ({
    password,
    passwordPolicy,
}: {
    password: string
    passwordPolicy?: PasswordPolicyResponse
}) => {
    const { minimumLength, requires } = passwordPolicy || defaultPasswordPolicy
    const result = checkPasswordPolicy(password, passwordPolicy)
    const policies = [
        {
            title: `At least ${minimumLength} characters`,
            passed: result.atLeast8Chars,
            required: true,
        },
        {
            title: "At least one uppercase letter",
            passed: result.atLeastOneUppercase,
            required: !!requires.uppercase,
        },
        {
            title: "At least one lowercase letter",
            passed: result.atLeastOneLowercase,
            required: !!requires.lowercase,
        },
        {
            title: "At least one number",
            passed: result.atLeastOneNumber,
            required: !!requires.numbers,
        },
        {
            title: "At least one symbol",
            passed: result.atLeastOneSymbol,
            required: !!requires.symbols,
        },
    ].filter((policy) => policy.required)
    const mid = Math.ceil(policies.length / 2)
    const firstHalf = policies.slice(0, mid)
    const secondHalf = policies.slice(mid)
    return (
        <div className="columns-2  w-full">
            <ul className="text-black-600 flex flex-col gap-2">
                {firstHalf.map((policy, idx) => (
                    <Item
                        key={idx}
                        title={policy.title}
                        passed={policy.passed}
                        password={password}
                    />
                ))}
            </ul>
            <ul className="text-black-600 flex flex-col gap-2">
                {secondHalf.map((policy, idx) => (
                    <Item
                        key={idx}
                        title={policy.title}
                        passed={policy.passed}
                        password={password}
                    />
                ))}
            </ul>
        </div>
    )
}

const Item = ({
    title,
    passed,
    password,
}: {
    title: string
    passed: boolean
    password: string
}) => {
    const isCorrect = passed
    const isError = !passed && password.length > 0
    const isDefault = !isCorrect && !isError
    return (
        <li className="flex gap-3 items-center text-black-600 leading-[32px] text-[16px]">
            {isDefault && (
                <div className="h-4 w-4 flex items-center justify-center mt-px">
                    <div className="h-2 w-2 border border-solid border-black-600 bg-transparent rounded-full" />
                </div>
            )}
            {isCorrect && (
                <Icons.ExtraSmallIcon Icon={Icons.Checkmark} className="text-green-600" />
            )}
            {isError && <Icons.ExtraSmallIcon Icon={Icons.XClose} className="text-red-600" />}
            <div className="leading-tight">{title}</div>
        </li>
    )
}
